




export const PART_API_BASE_URLS = {  
  
  GetListProducts : "/api/Product/externe-get-list-products",
  GetListSIs : "/api/SI/externe-get-list-SIs",
  Contact : "/api/Contact"
    
    // Ajoutez d'autres URLs d'API ici
  };